import React from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { ReframeSection } from './components/ReframeSection';
import { SolutionSection } from './components/SolutionSection';
import { BenefitsSection } from './components/BenefitsSection';
import { WhatsInside } from './components/WhatsInside';
import { Differentiation } from './components/Differentiation';
import { ObjectionHandling } from './components/ObjectionHandling';
import { SocialProof } from './components/SocialProof';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { FinalClose } from './components/FinalClose';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="min-h-screen bg-dark text-zinc-300 font-sans selection:bg-gold/30 selection:text-gold-light pb-0" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <PainSection data-id="element-3" />
        <ReframeSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <BenefitsSection data-id="element-6" />
        <WhatsInside data-id="element-7" />
        <Differentiation data-id="element-8" />
        <ObjectionHandling data-id="element-9" />
        <PricingSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <SocialProof data-id="element-12" />
        <FinalClose data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <StickyCTA data-id="element-15" />
    </div>;
}